import { render, staticRenderFns } from "./AddMetalModal.vue?vue&type=template&id=6f68d864"
import script from "./AddMetalModal.vue?vue&type=script&lang=js"
export * from "./AddMetalModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports